import styled from 'styled-components'

export const AiFlowActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
